var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.1,57.8c-6.5,0-9.4-8.9-9.4-17.1c0-6-5.3-9.6-5.3-9.6c-0.7-0.5-1.1-1.4-1-2.2c0.1-0.9,0.7-1.6,1.6-1.9 c2.9-0.9,4.6-6.1,4.6-13.8c0-3.8,1.5-7.2,4.4-9.7c2.1-1.8,4.2-2.6,4.4-2.6c1.2-0.4,2.5,0.2,2.9,1.4c0.4,1.2-0.2,2.5-1.4,2.9 c-0.3,0.1-5.7,2.1-5.7,8c0,7.9-1.6,13.4-4.7,16.3c2.1,2.2,4.8,6,4.8,11.2c0,6.7,2.3,12.5,4.8,12.5c1.3,0,2.3,1,2.3,2.3 C39.4,56.8,38.4,57.8,37.1,57.8z M72.3,40.7c0-6,5.3-9.6,5.3-9.6c0.7-0.5,1.2-1.4,1-2.2C78.5,28,77.9,27.3,77,27 c-2.9-0.9-4.6-6.1-4.6-13.8c0-3.8-1.5-7.2-4.4-9.7c-2.1-1.8-4.2-2.6-4.4-2.6c-1.2-0.4-2.5,0.2-2.9,1.4s0.2,2.5,1.4,2.9 c0.2,0.1,5.7,2.1,5.7,8c0,7.9,1.6,13.4,4.7,16.3c-2.1,2.2-4.8,6-4.8,11.2c0,6.7-2.3,12.5-4.8,12.5c-1.3,0-2.3,1-2.3,2.3 c0,1.3,1,2.3,2.3,2.3C69.3,57.8,72.3,49,72.3,40.7z M50,16.4c-2.2,0-4.1,1.8-4.1,4.1s1.8,4.1,4.1,4.1c2.2,0,4.1-1.8,4.1-4.1 S52.2,16.4,50,16.4z M54,36.6C54,36.6,54,36.6,54,36.6c-0.3-2-2-3.6-4-3.6c-2.2,0-4.1,1.8-4.1,4.1c0,1.9,1.3,3.5,3.1,4 c1.8,0.5,1.1,4.8,0.5,7.3c-0.1,0.3,0.3,0.4,0.5,0.2C54.8,40.2,54.1,36.8,54,36.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.6,88c0-3.4,2.4-5.7,5.8-5.7c1.9,0,3.5,0.8,4.4,2.2l-1.1,0.8c-0.8-1.1-2-1.7-3.3-1.7 c-2.5,0-4.3,1.8-4.3,4.4c0,2.7,1.8,4.4,4.3,4.4c1.3,0,2.5-0.5,3.3-1.7l1.1,0.8c-0.9,1.5-2.5,2.2-4.4,2.2 C27,93.7,24.6,91.3,24.6,88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.4,88c0-3.3,2.4-5.7,5.8-5.7s5.7,2.4,5.7,5.7c0,3.3-2.4,5.8-5.7,5.8S36.4,91.3,36.4,88z M46.4,88 c0-2.6-1.8-4.4-4.2-4.4c-2.4,0-4.2,1.8-4.2,4.4s1.8,4.4,4.2,4.4C44.6,92.4,46.4,90.6,46.4,88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61.3,77.7v15.9h-1.5v-2.2c-0.9,1.5-2.5,2.3-4.4,2.3c-3.2,0-5.6-2.3-5.6-5.8c0-3.4,2.4-5.7,5.6-5.7 c1.8,0,3.3,0.8,4.3,2.2v-6.8H61.3z M59.8,88c0-2.6-1.8-4.4-4.2-4.4c-2.4,0-4.2,1.8-4.2,4.4s1.8,4.4,4.2,4.4 C58,92.4,59.8,90.6,59.8,88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M75.4,88.4H66c0.2,2.4,2,3.9,4.4,3.9c1.4,0,2.6-0.5,3.5-1.5l0.9,1c-1,1.2-2.6,1.8-4.4,1.8 c-3.5,0-5.9-2.4-5.9-5.8c0-3.3,2.3-5.7,5.5-5.7c3.2,0,5.5,2.3,5.5,5.7C75.5,88.1,75.4,88.3,75.4,88.4z M66,87.3h8 c-0.2-2.2-1.8-3.8-4-3.8C67.8,83.5,66.2,85.1,66,87.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode);
export default __webpack_public_path__ + "static/media/code.08d0d2cac7470760a53c3556c7f7d496.svg";
export { ForwardRef as ReactComponent };